// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./animation.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dosis:wght@200..800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(http://wrraptheme.com/demo/assets/thinder-ai-style.css);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Body */
body {
    line-height: 22px;
    font-family: 'Raleway', sans-serif;
}

body.font-raleway {
    font-family: 'Raleway', sans-serif;
}

body.font-opensans {
    font-family: "Open Sans", sans-serif;
}

body.font-dosis {
    font-family: "Dosis", sans-serif;
}

body.font-jost {
    font-family: "Jost", sans-serif;
}

.choose-skin li div {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
}
.choose-skin li:hover{
    cursor: pointer;
}
.choose-skin li.active div:after{
    content: '';
    position: absolute;
    z-index: 99;
    width: 10px;
    height: 10px;
    background: var(--bs-white);
    border-radius: 10px;
}

body.radius-0 .rounded,
body.radius-0 .rounded-1,
body.radius-0 .rounded-2,
body.radius-0 .rounded-3,
body.radius-0 .rounded-4,
body.radius-0 .btn,
body.radius-0 .form-control {
    border-radius: 0 !important;
}

/* Tab Card Headers */
.tab-header.nav-tabs .nav-link {
    border: 0;
    padding: 2px 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-black-50);
}

.tab-header.nav-tabs .nav-item.show .nav-link,
.tab-header.nav-tabs .nav-link.active {
    color: var(--bs-light-text-emphasis);
    background-color: transparent;
}

/* Tab Card Headers */

/* Header */
.header {
    background-color: var(--bs-body-bg);
    z-index: 1022;
}

.header .logo {
    width: 221px;
    border-right: 1px solid var(--bs-border-color);
}

.header .dropdown-toggle {
    padding: 0;
    border: none;
}

.header .dropdown-toggle::after {
    display: none;
}

.header .nav-link {
    font-size: 18px;
    line-height: 21px;
    font-weight: 400;
    color: var(--bs-body-color);
}

.header .nav-link:hover {
    color: var(--bs-primary);
}

.header .nav-link:hover svg path {
    stroke: var(--bs-primary);
    stroke-width: 2px;
    transition: var(--transition-3s);
}

.header .nav-link:hover {
    color: var(--bs-primary);
}

.header .dropdown-menu.notifications,
.header .dropdown-menu.notifications a {
    width: 360px;
    font-size: 16px;
    line-height: 22px;
    color: var(--bs-body-color);
    text-decoration: none;
}


.header .dropdown-menu.notifications .list-group {
    height: 300px;
    overflow-y: auto;
}

.header .dropdown-menu.notifications .list-group-item {
    border-style: dashed;
}

.header .dropdown-menu.notifications .list-group-item:hover a {
    color: var(--bs-primary);
}

.page-search .icon-search {
    left: 24px;
    z-index: 10;
}

.page-search .icon-cmd {
    right: 24px;
    z-index: 10;
}

.page-search .form-control {
    padding-left: 62px !important;
    padding-right: 115px !important;
    background-color: var(--bs-card-bg);
    border: 1px solid var(--bs-card-bg);
}

.page-search .form-control:focus {
    box-shadow: 0 0 0 .25rem rgba(108, 80, 191, .25);
    border-color: var(--bs-primary);
}

.search-result {
    transition: var(--transition-3s);
    opacity: 1;
    visibility: visible;
    transform: scaleY(1);
    height: 100%;
}

.search-result.active {
    opacity: 0;
    visibility: hidden;
    transform: scaleY(0);
    transition: var(--transition-3s);
    height: 0;
}

.search-result .card{
    border-bottom-width: 5px;
}

[data-bs-theme=light] .search-result .card{ 
    background: #f8f9fa;
}

/* Header */

/* Page Modules */
.page-modules .row {
    margin-left: -20px;
    margin-right: -20px;
}

.page-modules .module-item .module-box {
    padding: 30px;
    background: linear-gradient(136.25deg, var(--bs-card-bg) 2.1%, var(--bs-card-bg) 100%);
    color: var(--bs-body-color);
    transition: var(--transition-3s)
}

.page-modules .module-item:focus .module-box,
.page-modules .module-item:hover .module-box {
    background: linear-gradient(136.25deg, var(--bs-primary) 2.1%, #322559 100%);
    color: var(--bs-white);
    transition: var(--transition-3s)
}

.page-modules .module-item:focus .module-box svg path,
.page-modules .module-item:hover .module-box svg path {
    stroke-width: 2px;
}

.page-modules .module-item .module-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: var(--bs-body-color);
    transition: var(--transition-3s)
}

.page-modules .module-item:hover .module-title {
    font-weight: 700;
    color: var(--bs-primary);
}

.modal .page-modules .module-item .module-title {
    font-size: 16px;
}
.app-icon h6{ font-size: 14px !important;}
.app-icon .module-box{ padding: 16px !important;}

/* Page Modules */

/* Content Wrapper */
.content-wrapper {
    width: 100%;
    min-height: calc(100vh - 136px);
    transition: var(--transition-3s);
}

.content-wrapper.content-wrapper-radius {
    background-color: var(--bs-card-bg);
}

.content-wrapper.content-wrapper-radius .left-sidebar {
    border-radius: 0 16px 0 0;
}

.content-wrapper.content-wrapper-radius .content-area {
    border-radius: 16px 0 0 0;
    background-color: var(--bs-body-bg);
}

/* Content Wrapper */

/* Left Sidebar */
.left-sidebar {
    width: 245px;
    min-width: 245px;
    /* max-height: 100vh; */
    background-color: var(--bs-body-bg);
    overflow-y: auto;
    transition: var(--transition-3s);
    padding: 24px 20px;
    position: relative;
}

.layout-fullwidth .left-sidebar {
    width: 0;
    min-width: 0;
    padding: 24px 0;
    transition: var(--transition-3s);
    left: -250px;
}

.left-sidebar .nav-sidebar {
    width: 204px;
}

.nav-sidebar>ul>li {
    margin-bottom: 20px;
}

.nav-sidebar>ul>li:last-child {
    margin-bottom: 0;
}

.nav-sidebar .nav {
    position: relative;
    padding-top: 14px;
}

.nav-sidebar .nav::before {
    content: '';
    position: absolute;
    top: 0;
    left: 5px;
    width: 2px;
    height: calc(100% - 23px);
    z-index: 1;
    background-color: var(--bs-border-color);
    transition: var(--transition-3s);
}

.nav-sidebar .nav-title {
    display: block;
    color: var(--bs-body-color);
}

.nav-sidebar ul li a[aria-expanded="false"] svg {
    transform: rotate(0deg);
    transition: var(--transition-3s);
}

.nav-sidebar ul li a[aria-expanded="true"] svg {
    transform: rotate(135deg);
    transition: var(--transition-3s);
}

.nav-sidebar .nav .nav-item {
    padding: 4px 0 4px 24px;
    position: relative;
}

.nav-sidebar .nav .nav-item::before {
    content: "";
    border-left: 2px solid var(--bs-border-color);
    border-bottom: 2px solid var(--bs-border-color);
    width: 12px;
    height: 12px;
    position: absolute;
    left: 5px;
    top: 4px;
    border-radius: 0px 8px 0px 8px;
}

.nav-sidebar .nav .nav-link {
    padding: 0;
    line-height: 22px;
    color: var(--bs-body-color);
}

.nav-sidebar .nav .nav-link:focus,
.nav-sidebar .nav .nav-link.active,
.nav-sidebar .nav .nav-link:hover {
    color: var(--bs-primary);
    font-weight: 500;
    transition: var(--transition-3s);
}

/* Sidebar Overlay */
.sidebar-overlay {
    display: none;
}

/* Body Scroll */
body.no-scroll {
    position: fixed;
    width: 100%;
}

/* Left Sidebar */

/* Content Wrapper */
.content-area {
    min-width: calc(100% - 245px);
    transition: var(--transition-3s);
}

.content-area>.container-fluid {
    height: 100%;
}

.layout-fullwidth .content-area {
    width: 100%;
}

/* Content Wrapper */

.sub-layout .content-wrapper {
    background-color: var(--bs-card-bg);
}

.sub-layout .left-sidebar {
    border-radius: 0 16px 0 0;
    background-color: var(--bs-body-bg);
}

.sub-layout .body-area {
    border-radius: 16px 0 0 0;
    background-color: var(--bs-body-bg);
    width: calc(100% - 245px);
    height: calc(100vh - 138px);
}

.sub-layout .body-area .message-list {
    height: calc(100% - 125px);
}

.sub-layout .body-area .ai-image-card {
    width: 75%;
}

#chat-file-input {
    display: none;
}

.send-image {
    height: 100px;
    width: 100px;
}

.typing-dots::after {
    content: '';
    display: inline-block;
    width: 1em;
    text-align: left;
    animation: dots 1.2s steps(3, end) infinite;
}

@keyframes dots {
    0% {
        content: '';
    }

    33% {
        content: '.';
    }

    66% {
        content: '..';
    }

    100% {
        content: '...';
    }
}

#PageSearchInput {
    width: 0;
    opacity: 0;
    transition: width 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
    overflow: hidden;
    right: -10px;
    top: -6px;
}

#PageSearchInput.active {
    width: 240px;
    opacity: 1;
}


.breadcrumbs-primary .page-breadcrumbs .page-name{
    color: var(--bs-white);
}
.breadcrumbs-primary .page-breadcrumbs .back-btn{
    border-color: #eeeeee36;
}
.breadcrumbs-primary .page-breadcrumbs,
.breadcrumbs-primary .content-wrapper.content-wrapper-radius,
.breadcrumbs-primary .inner-layout .left-bar{
    background-color: var(--bs-primary);
}
.breadcrumbs-primary .back-btn span{
    color: var(--bs-white) !important;
}
.breadcrumbs-primary .page-breadcrumbs .hover-svg svg path{
    stroke: var(--bs-white)
}
.breadcrumbs-primary .page-breadcrumbs .hover-svg:hover svg path{
    stroke: var(--bs-black)
}
.breadcrumbs-primary.sub-layout .content-wrapper{
    background-color: var(--bs-primary);
}
.breadcrumbs-primary .inner-layout .left-bar .list-group-item.active,
.breadcrumbs-primary .inner-layout .left-bar .list-group-item:hover{
    background: rgb(0 0 0 / 10%);
    color: var(--bs-white);
}

.card.shadow-active{
    box-shadow: var(--bs-box-shadow-sm)!important
}

.gemini-ai{

}
.gemini-text{
    background: linear-gradient(to right, #4285f4, #9b72cb, #d96570);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    animation: gradient 5s linear infinite;
}
@keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/styles.css"],"names":[],"mappings":"AAUA,SAAS;AACT;IACI,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;;;;;;IAOI,2BAA2B;AAC/B;;AAEA,qBAAqB;AACrB;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;;IAEI,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA,qBAAqB;;AAErB,WAAW;AACX;IACI,mCAAmC;IACnC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA;IACI,gDAAgD;IAChD,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,WAAW;;AAEX,iBAAiB;AACjB;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sFAAsF;IACtF,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,4EAA4E;IAC5E,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;AACA,cAAc,0BAA0B,CAAC;AACzC,uBAAuB,wBAAwB,CAAC;;AAEhD,iBAAiB;;AAEjB,oBAAoB;AACpB;IACI,WAAW;IACX,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA,oBAAoB;;AAEpB,iBAAiB;AACjB;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mCAAmC;IACnC,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,UAAU;IACV,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,+CAA+C;IAC/C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;;;IAGI,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,oBAAoB;AACpB;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,WAAW;AACf;;AAEA,iBAAiB;;AAEjB,oBAAoB;AACpB;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,oBAAoB;;AAEpB;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,iEAAiE;IACjE,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;;AAGA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;AACA;;;IAGI,mCAAmC;AACvC;AACA;IACI,iCAAiC;AACrC;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,mCAAmC;AACvC;AACA;;IAEI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;;AAEA;AACA;IACI,gEAAgE;IAChE,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;AAC1C;AACA;IACI;MACE,2BAA2B;IAC7B;IACA;MACE,6BAA6B;IAC/B;IACA;MACE,2BAA2B;IAC7B;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Dosis:wght@200..800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('http://wrraptheme.com/demo/assets/thinder-ai-style.css');\n\n@import url(theme.css);\n@import url(base.css);\n@import url(animation.css);\n\n/* Body */\nbody {\n    line-height: 22px;\n    font-family: 'Raleway', sans-serif;\n}\n\nbody.font-raleway {\n    font-family: 'Raleway', sans-serif;\n}\n\nbody.font-opensans {\n    font-family: \"Open Sans\", sans-serif;\n}\n\nbody.font-dosis {\n    font-family: \"Dosis\", sans-serif;\n}\n\nbody.font-jost {\n    font-family: \"Jost\", sans-serif;\n}\n\n.choose-skin li div {\n    display: flex;\n    position: relative;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n}\n.choose-skin li:hover{\n    cursor: pointer;\n}\n.choose-skin li.active div:after{\n    content: '';\n    position: absolute;\n    z-index: 99;\n    width: 10px;\n    height: 10px;\n    background: var(--bs-white);\n    border-radius: 10px;\n}\n\nbody.radius-0 .rounded,\nbody.radius-0 .rounded-1,\nbody.radius-0 .rounded-2,\nbody.radius-0 .rounded-3,\nbody.radius-0 .rounded-4,\nbody.radius-0 .btn,\nbody.radius-0 .form-control {\n    border-radius: 0 !important;\n}\n\n/* Tab Card Headers */\n.tab-header.nav-tabs .nav-link {\n    border: 0;\n    padding: 2px 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-black-50);\n}\n\n.tab-header.nav-tabs .nav-item.show .nav-link,\n.tab-header.nav-tabs .nav-link.active {\n    color: var(--bs-light-text-emphasis);\n    background-color: transparent;\n}\n\n/* Tab Card Headers */\n\n/* Header */\n.header {\n    background-color: var(--bs-body-bg);\n    z-index: 1022;\n}\n\n.header .logo {\n    width: 221px;\n    border-right: 1px solid var(--bs-border-color);\n}\n\n.header .dropdown-toggle {\n    padding: 0;\n    border: none;\n}\n\n.header .dropdown-toggle::after {\n    display: none;\n}\n\n.header .nav-link {\n    font-size: 18px;\n    line-height: 21px;\n    font-weight: 400;\n    color: var(--bs-body-color);\n}\n\n.header .nav-link:hover {\n    color: var(--bs-primary);\n}\n\n.header .nav-link:hover svg path {\n    stroke: var(--bs-primary);\n    stroke-width: 2px;\n    transition: var(--transition-3s);\n}\n\n.header .nav-link:hover {\n    color: var(--bs-primary);\n}\n\n.header .dropdown-menu.notifications,\n.header .dropdown-menu.notifications a {\n    width: 360px;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--bs-body-color);\n    text-decoration: none;\n}\n\n\n.header .dropdown-menu.notifications .list-group {\n    height: 300px;\n    overflow-y: auto;\n}\n\n.header .dropdown-menu.notifications .list-group-item {\n    border-style: dashed;\n}\n\n.header .dropdown-menu.notifications .list-group-item:hover a {\n    color: var(--bs-primary);\n}\n\n.page-search .icon-search {\n    left: 24px;\n    z-index: 10;\n}\n\n.page-search .icon-cmd {\n    right: 24px;\n    z-index: 10;\n}\n\n.page-search .form-control {\n    padding-left: 62px !important;\n    padding-right: 115px !important;\n    background-color: var(--bs-card-bg);\n    border: 1px solid var(--bs-card-bg);\n}\n\n.page-search .form-control:focus {\n    box-shadow: 0 0 0 .25rem rgba(108, 80, 191, .25);\n    border-color: var(--bs-primary);\n}\n\n.search-result {\n    transition: var(--transition-3s);\n    opacity: 1;\n    visibility: visible;\n    transform: scaleY(1);\n    height: 100%;\n}\n\n.search-result.active {\n    opacity: 0;\n    visibility: hidden;\n    transform: scaleY(0);\n    transition: var(--transition-3s);\n    height: 0;\n}\n\n.search-result .card{\n    border-bottom-width: 5px;\n}\n\n[data-bs-theme=light] .search-result .card{ \n    background: #f8f9fa;\n}\n\n/* Header */\n\n/* Page Modules */\n.page-modules .row {\n    margin-left: -20px;\n    margin-right: -20px;\n}\n\n.page-modules .module-item .module-box {\n    padding: 30px;\n    background: linear-gradient(136.25deg, var(--bs-card-bg) 2.1%, var(--bs-card-bg) 100%);\n    color: var(--bs-body-color);\n    transition: var(--transition-3s)\n}\n\n.page-modules .module-item:focus .module-box,\n.page-modules .module-item:hover .module-box {\n    background: linear-gradient(136.25deg, var(--bs-primary) 2.1%, #322559 100%);\n    color: var(--bs-white);\n    transition: var(--transition-3s)\n}\n\n.page-modules .module-item:focus .module-box svg path,\n.page-modules .module-item:hover .module-box svg path {\n    stroke-width: 2px;\n}\n\n.page-modules .module-item .module-title {\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 400;\n    color: var(--bs-body-color);\n    transition: var(--transition-3s)\n}\n\n.page-modules .module-item:hover .module-title {\n    font-weight: 700;\n    color: var(--bs-primary);\n}\n\n.modal .page-modules .module-item .module-title {\n    font-size: 16px;\n}\n.app-icon h6{ font-size: 14px !important;}\n.app-icon .module-box{ padding: 16px !important;}\n\n/* Page Modules */\n\n/* Content Wrapper */\n.content-wrapper {\n    width: 100%;\n    min-height: calc(100vh - 136px);\n    transition: var(--transition-3s);\n}\n\n.content-wrapper.content-wrapper-radius {\n    background-color: var(--bs-card-bg);\n}\n\n.content-wrapper.content-wrapper-radius .left-sidebar {\n    border-radius: 0 16px 0 0;\n}\n\n.content-wrapper.content-wrapper-radius .content-area {\n    border-radius: 16px 0 0 0;\n    background-color: var(--bs-body-bg);\n}\n\n/* Content Wrapper */\n\n/* Left Sidebar */\n.left-sidebar {\n    width: 245px;\n    min-width: 245px;\n    /* max-height: 100vh; */\n    background-color: var(--bs-body-bg);\n    overflow-y: auto;\n    transition: var(--transition-3s);\n    padding: 24px 20px;\n    position: relative;\n}\n\n.layout-fullwidth .left-sidebar {\n    width: 0;\n    min-width: 0;\n    padding: 24px 0;\n    transition: var(--transition-3s);\n    left: -250px;\n}\n\n.left-sidebar .nav-sidebar {\n    width: 204px;\n}\n\n.nav-sidebar>ul>li {\n    margin-bottom: 20px;\n}\n\n.nav-sidebar>ul>li:last-child {\n    margin-bottom: 0;\n}\n\n.nav-sidebar .nav {\n    position: relative;\n    padding-top: 14px;\n}\n\n.nav-sidebar .nav::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 5px;\n    width: 2px;\n    height: calc(100% - 23px);\n    z-index: 1;\n    background-color: var(--bs-border-color);\n    transition: var(--transition-3s);\n}\n\n.nav-sidebar .nav-title {\n    display: block;\n    color: var(--bs-body-color);\n}\n\n.nav-sidebar ul li a[aria-expanded=\"false\"] svg {\n    transform: rotate(0deg);\n    transition: var(--transition-3s);\n}\n\n.nav-sidebar ul li a[aria-expanded=\"true\"] svg {\n    transform: rotate(135deg);\n    transition: var(--transition-3s);\n}\n\n.nav-sidebar .nav .nav-item {\n    padding: 4px 0 4px 24px;\n    position: relative;\n}\n\n.nav-sidebar .nav .nav-item::before {\n    content: \"\";\n    border-left: 2px solid var(--bs-border-color);\n    border-bottom: 2px solid var(--bs-border-color);\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    left: 5px;\n    top: 4px;\n    border-radius: 0px 8px 0px 8px;\n}\n\n.nav-sidebar .nav .nav-link {\n    padding: 0;\n    line-height: 22px;\n    color: var(--bs-body-color);\n}\n\n.nav-sidebar .nav .nav-link:focus,\n.nav-sidebar .nav .nav-link.active,\n.nav-sidebar .nav .nav-link:hover {\n    color: var(--bs-primary);\n    font-weight: 500;\n    transition: var(--transition-3s);\n}\n\n/* Sidebar Overlay */\n.sidebar-overlay {\n    display: none;\n}\n\n/* Body Scroll */\nbody.no-scroll {\n    position: fixed;\n    width: 100%;\n}\n\n/* Left Sidebar */\n\n/* Content Wrapper */\n.content-area {\n    min-width: calc(100% - 245px);\n    transition: var(--transition-3s);\n}\n\n.content-area>.container-fluid {\n    height: 100%;\n}\n\n.layout-fullwidth .content-area {\n    width: 100%;\n}\n\n/* Content Wrapper */\n\n.sub-layout .content-wrapper {\n    background-color: var(--bs-card-bg);\n}\n\n.sub-layout .left-sidebar {\n    border-radius: 0 16px 0 0;\n    background-color: var(--bs-body-bg);\n}\n\n.sub-layout .body-area {\n    border-radius: 16px 0 0 0;\n    background-color: var(--bs-body-bg);\n    width: calc(100% - 245px);\n    height: calc(100vh - 138px);\n}\n\n.sub-layout .body-area .message-list {\n    height: calc(100% - 125px);\n}\n\n.sub-layout .body-area .ai-image-card {\n    width: 75%;\n}\n\n#chat-file-input {\n    display: none;\n}\n\n.send-image {\n    height: 100px;\n    width: 100px;\n}\n\n.typing-dots::after {\n    content: '';\n    display: inline-block;\n    width: 1em;\n    text-align: left;\n    animation: dots 1.2s steps(3, end) infinite;\n}\n\n@keyframes dots {\n    0% {\n        content: '';\n    }\n\n    33% {\n        content: '.';\n    }\n\n    66% {\n        content: '..';\n    }\n\n    100% {\n        content: '...';\n    }\n}\n\n#PageSearchInput {\n    width: 0;\n    opacity: 0;\n    transition: width 0.3s ease, opacity 0.3s ease, padding 0.3s ease;\n    overflow: hidden;\n    right: -10px;\n    top: -6px;\n}\n\n#PageSearchInput.active {\n    width: 240px;\n    opacity: 1;\n}\n\n\n.breadcrumbs-primary .page-breadcrumbs .page-name{\n    color: var(--bs-white);\n}\n.breadcrumbs-primary .page-breadcrumbs .back-btn{\n    border-color: #eeeeee36;\n}\n.breadcrumbs-primary .page-breadcrumbs,\n.breadcrumbs-primary .content-wrapper.content-wrapper-radius,\n.breadcrumbs-primary .inner-layout .left-bar{\n    background-color: var(--bs-primary);\n}\n.breadcrumbs-primary .back-btn span{\n    color: var(--bs-white) !important;\n}\n.breadcrumbs-primary .page-breadcrumbs .hover-svg svg path{\n    stroke: var(--bs-white)\n}\n.breadcrumbs-primary .page-breadcrumbs .hover-svg:hover svg path{\n    stroke: var(--bs-black)\n}\n.breadcrumbs-primary.sub-layout .content-wrapper{\n    background-color: var(--bs-primary);\n}\n.breadcrumbs-primary .inner-layout .left-bar .list-group-item.active,\n.breadcrumbs-primary .inner-layout .left-bar .list-group-item:hover{\n    background: rgb(0 0 0 / 10%);\n    color: var(--bs-white);\n}\n\n.card.shadow-active{\n    box-shadow: var(--bs-box-shadow-sm)!important\n}\n\n.gemini-ai{\n\n}\n.gemini-text{\n    background: linear-gradient(to right, #4285f4, #9b72cb, #d96570);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    color: transparent;\n    animation: gradient 5s linear infinite;\n}\n@keyframes gradient {\n    0% {\n      background-position: 0% 50%;\n    }\n    50% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: 0% 50%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
